import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";
import { cn } from "@/shared/utils/style.util";

type LegalDocumentLinksProps = {
  documents: LegalDocument[]
  onOpen: (document: LegalDocument) => void
  className?: string
  linkClassName?: string
};

export const LegalDocumentLinks = ({
  documents, onOpen, className = "", linkClassName = "text-sm text-primary",
}: LegalDocumentLinksProps) => (
  <ul className={cn("flex flex-wrap gap-x-4 gap-y-1", className)}>
    {documents.map((document) => (
      <li key={document.key}>
        <button
          type="button"
          className={cn("underline underline-offset-2", linkClassName)}
          onClick={() => onOpen(document)}
          data-testid={`legal-document-link-${document.key}`}
        >
          {document.title}
        </button>
      </li>
    ))}
  </ul>
);

LegalDocumentLinks.displayName = "LegalDocumentLinks";
